import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Drawer, Flex } from 'antd';

function GraphKFeed({statsData, open, close}) {

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip, Filler,
    Legend
  );
  const options = {

      maintainAspectRatio: false,
  
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    stacked: false,
    plugins: {
        legend: {
            position: "bottom",
            // maxWidth: 200,
            labels: {
                boxWidth: 16,
                boxHeight: 16,
            }},
      title: {
        display: false,
        //text: 'Кол-во запрос по kfeed/день за последние 30 дней',
      },
    },
    scales: {
      x: {
        ticks: {
    
          font: {
              size: 8,
          }
      }
      },
      y: {
        type: 'linear',
        display: true,
        position: 'left',
        ticks: {
    
          font: {
              size: 8,
          }
      }
      },
    },
  };


  const data = {
    labels: statsData !== null ? statsData.map((item, index) => { return item.date }) : '',
    datasets: [
      {
        fill: true,
        label: 'Кол-во запросов',
        data: statsData !== null && statsData.map((item, index) => { return item.count }),
        datalabels: {
          color: 'black',
          opacity: 0
        },
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, .2)',
        yAxisID: 'y',
      },
    ],
  };
  return (
  
    <Drawer
    open={open}
    onClose={close}
    maskClosable={true}
    width={704}
    
    //styles={{ header: {display: "none"}}}
    >
    <div style={{ width: '100%', height: '400px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <span style={{ fontSize: '12px', color: '#8090B8', textAlign: 'center'}}>{'Кол-во запросов по kfeed/день за последние 30 дней'.toUpperCase()}</span>
      <Line options={options} data={data} />
      </div>
      
      </Drawer>
  )
}

export default GraphKFeed;